import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, FilteredCommand } from '../../../core/model/command';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { Observable } from 'rxjs';
import { PremisesService } from '../data/premises.service';

@Injectable()
export class PremisesExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: PremisesService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.export && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof FilteredCommand) {
      return this._dataService
        .export(command.filterProvider.filterState, command.includedIds, command.excludedIds, command.totalAffectedItemsControlValue)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
